import * as React from 'react';
export const LVSvg = React.forwardRef(function LVSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        d: 'M1.994 2h12.012A2 2 0 0 1 16 4.005V7H0V4.005C0 2.894.893 2 1.994 2ZM0 9h16v2.995A1.997 1.997 0 0 1 14.006 14H1.994A2 2 0 0 1 0 11.995V9Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 7h16v2H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14.933 9V7H16v2h-1.067ZM0 7h1.067v2H0V7Z',
      }),
    ),
  );
});
LVSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LV = {
  category: 'flag',
  colorable: false,
  name: 'LV',
  svg: LVSvg,
};
